import React from "react";

function MeepleHeadset({
  style,
  role,
}: {
  style: React.CSSProperties | undefined;
  role: string | undefined;
}) {
  return (
    <svg
      id="uuid-508caeba-eb2f-4694-acb1-d99de4fc9df9"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      style={style}
      role={role}
    >
      <circle
        style={{
          strokeWidth: 0,
          fill: style?.color || "black",
        }}
        cx="8"
        cy="4"
        r="4"
      />
      <path
        style={{ strokeWidth: 0, fill: style?.color || "black" }}
        d="M16,14v2H0v-2c0-1.67.78-2.38,3-3l3,3c.25-.57.98-2.11,1.3-2.49l.61.28c.05.05.13.05.18,0l.61-.28c.32.38,1.05,1.92,1.3,2.49l3-3c2.22.62,3,1.33,3,3Z"
      />
      <path
        style={{ strokeWidth: 0, fill: style?.color || "black" }}
        d="M8,10c2.2,0,3.31.34,2.47.76s-1.72.82-1.94.89-.48.16-.58.19l-.07-.05h0c-.45-.15-1.5-.62-2.35-1.03s.27-.76,2.47-.76h0Z"
      />
      <path
        style={{ strokeWidth: 0, fill: style?.color || "black", }}
        d="M8.7,11.51l-.61.28c-.05.05-.13.05-.18,0l-.61-.28c.25-.32.51-.57.7-.75.19.18.45.43.7.75Z"
      />
    </svg>
  );
}

export default MeepleHeadset;
